import { Quote, Sparkles } from "lucide-react";

const testimonials = [
  {
    quote:
      "The Health Score didn't just give me a number — it told me exactly why my sleep was pulling everything down. First time I felt an app actually explained itself.",
    name: "Ananya R.",
    role: "Software Engineer, Bengaluru",
  },
  {
    quote:
      "My grandmother had diabetes; I always worried. SilentScan AI gave me a preventive check-in and an Indian diet plan I could actually cook. Small changes, real clarity.",
    name: "Rahul M.",
    role: "Student, Chennai",
  },
  {
    quote:
      "The mental wellness check-in is what surprised me. It was gentle, respectful, and pointed me to real support — not a diagnosis.",
    name: "Priya S.",
    role: "Marketing Manager, Mumbai",
  },
];

export default function Testimonials() {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="relative py-28 md:py-36"
    >
      <div className="absolute inset-0 grid-radial opacity-50 pointer-events-none" />
      <div className="relative max-w-6xl mx-auto px-6">
        <div className="text-center max-w-3xl mx-auto mb-14">
          <div className="inline-flex items-center gap-2 rounded-full glass-card px-4 py-1.5 mb-6">
            <Sparkles className="w-3.5 h-3.5 text-cyan-400" />
            <span className="text-[10px] font-semibold uppercase tracking-[0.2em] text-cyan-400">
              Illustrative testimonials
            </span>
          </div>
          <h2 className="font-display text-4xl sm:text-5xl font-semibold tracking-[-0.03em] leading-tight">
            Built for real{" "}
            <span className="text-gradient-cyan">Indian users.</span>
          </h2>
          <p className="mt-4 text-zinc-500 text-sm">
            These reflect the kind of feedback we hear during pilot check-ins.
            Product is in early preview.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-5">
          {testimonials.map((t, i) => (
            <div
              key={i}
              data-testid={`testimonial-${i}`}
              className="glass-card rounded-3xl p-7 flex flex-col"
            >
              <Quote className="w-6 h-6 text-cyan-400 mb-4" />
              <p className="text-zinc-200 leading-relaxed text-sm flex-1">
                "{t.quote}"
              </p>
              <div className="mt-6 pt-4 border-t border-white/5">
                <div className="text-sm font-semibold text-white">{t.name}</div>
                <div className="text-xs text-zinc-500 mt-0.5">{t.role}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
